// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.billing-history-container {
    width: 85%;
    overflow: hidden;
    margin: 50px 20px 20px 20px;
    height: -webkit-fill-available;
}

.billing-history-container h2 {
    color: #004BA0;
}

td {
    font-size: 14px !important;
}
`, "",{"version":3,"sources":["webpack://./src/app/dashboard/css/billing-history.css"],"names":[],"mappings":"AAAA;IACI,UAAU;IACV,gBAAgB;IAChB,2BAA2B;IAC3B,8BAA8B;AAClC;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,0BAA0B;AAC9B","sourcesContent":[".billing-history-container {\n    width: 85%;\n    overflow: hidden;\n    margin: 50px 20px 20px 20px;\n    height: -webkit-fill-available;\n}\n\n.billing-history-container h2 {\n    color: #004BA0;\n}\n\ntd {\n    font-size: 14px !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
